<template>
    <b-modal
        id="regional-word-create"
        size="lg"
        v-model="showCreateRegionalWordForm"
        :hide-footer="true"
        @hide="confirmAction"
    >
        <template #modal-header="{ close }">
            <div class="header-left">
                <h2>Pievienot apvidvārdu</h2>
            </div>
            <b-icon
                class="close-icon"
                icon="x-circle-fill"
                @click="close()"
            ></b-icon>
        </template>
        <b-row class="ml-0 mr-0 mt-2 mb-2 instructions">
            <b-link
                target="_blank"
                :to="'/instrukcija'"
                class="link-to-instructions"
                >Saite uz instrukciju</b-link
            >
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-icon
                v-b-tooltip.hover.leftbottom="
                    'Apvidvārdi – kādā noteiktā apvidū lietoti vārdi, kas nepieder literārās valodas leksikai'
                "
                class="info-tooltip-icon"
                icon="question"
            ></b-icon>
            <b-form-group
                class="name"
                :invalid-feedback="formErrors.name"
                :state="!formErrors.name"
            >
                <b-form-input
                    @keyup.enter="saveRegionalWord"
                    v-model="newRegionalWordForm.name"
                    placeholder="Apvidvārds*"
                ></b-form-input>
            </b-form-group>
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-icon
                v-b-tooltip.hover.leftbottom="'Ievadītā apvidvārda nozīme'"
                class="info-tooltip-icon"
                icon="question"
            ></b-icon>
            <b-form-group
                class="description"
                :invalid-feedback="formErrors.description"
                :state="!formErrors.description"
            >
                <b-form-input
                    @keyup.enter="saveRegionalWord"
                    v-model="newRegionalWordForm.description"
                    placeholder="Nozīme*"
                ></b-form-input>
            </b-form-group>
        </b-row>
        <b-row class="location-row ml-0 mr-0 mt-2 mb-4 pb-4 pt-4">
            <!-- <b-icon
                v-b-tooltip
                title="Vieta, kur apvidvārds tiek lietots. Papildu informācija par vietu norādāma piezīmēs."
                class="info-tooltip-icon"
                icon="question"
            ></b-icon> -->
            <b-form-group
                class="location mb-0"
                :invalid-feedback="formErrors.administrative_territories_id"
                :state="!formErrors.administrative_territories_id"
            >
                <b-form-select
                    class="location"
                    v-model="newRegionalWordForm.administrative_territories_id"
                    :options="administrativeTerritoriesList"
                    value-field="id"
                    text-field="name"
                ></b-form-select>
            </b-form-group>
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-icon
                v-b-tooltip.hover.leftbottom="
                    'Piemēri, kādos ievadītais apvidvārds tiek lietots. Tas var būt vārdu savienojums, teikums vai garāks teksts.'
                "
                class="info-tooltip-icon-textarea"
                icon="question"
            ></b-icon>
            <b-form-group class="example">
                <b-form-textarea
                    @keyup.enter="saveRegionalWord"
                    v-model="newRegionalWordForm.example"
                    placeholder="Piemērs"
                    rows="3"
                    max-rows="8"
                ></b-form-textarea>
            </b-form-group>
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-icon
                v-b-tooltip.hover.leftbottom="
                    'Šeit var rakstīt visu, kas attiecas uz ievadīto apvidvārdu – piezīmes par izrunu, vārda lietošanas teritoriju, locījumiem, neparastām formām, vārda lietotāju vecumu, informācija par teicēju (cilvēks, kas šo vārdu teicis) utt.'
                "
                class="info-tooltip-icon-textarea"
                icon="question"
            ></b-icon>
            <b-form-group class="notes">
                <b-form-textarea
                    @keyup.enter="saveRegionalWord"
                    v-model="newRegionalWordForm.notes"
                    placeholder="Piezīmes"
                    rows="3"
                    max-rows="8"
                ></b-form-textarea>
            </b-form-group>
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 audio-recorder-wrapper">
            <label>Ierakstīt audio piemēru</label>
            <b-col cols="12" class="audio-file">
                <b-icon
                    v-if="showRecordButton && !audio_file"
                    :disabled="audioRecording"
                    class="record-icon pr-2"
                    icon="mic"
                    @click="recordAudio()"
                ></b-icon>
                <b-icon
                    v-if="showRecordButton && audio_file"
                    class="record-icon pr-2"
                    icon="arrow-clockwise"
                    @click="redoRecording()"
                ></b-icon>
                <!-- <span v-if="showRecordButton" class="icon-divider"> | </span> -->
                <b-icon
                    v-if="showStopButton"
                    class="stop-icon pl-2"
                    icon="stop-fill"
                    @click="stopAudioRecording()"
                ></b-icon>
                <span
                    v-if="elapsedTime && !showRecordButton"
                    class="elapsed-time pl-2"
                    >{{ elapsedTime }}</span
                >
                <b-icon
                    v-if="showRecordButton && audio_file"
                    class="cancel-recording pl-2"
                    icon="trash"
                    @click="cancelAudioRecording()"
                ></b-icon>
                <audio
                    class="pl-2"
                    v-if="audio_blob && showRecordButton"
                    controls
                >
                    <source :src="audio_blob" />
                </audio>
            </b-col>
        </b-row>
        <b-row class="actions ml-0 mr-0 mt-2 mb-2">
            <b-button
                :disabled="audioRecording"
                @click="saveRegionalWord()"
                class="create-regional-word-button"
            >
                Saglabāt
            </b-button>
        </b-row>
        <b-modal
            id="confirm-action"
            title="Pārtraukt apvidvārda rediģēšanu?"
            v-model="showConfirmationModal"
            :hide-footer="true"
            no-close-on-esc
            no-close-on-backdrop
            @hide="showConfirmationModal = false"
        >
            <b-row class="actions ml-0 mr-0 mt-2 mb-2">
                <b-button
                    @click="showConfirmationModal = false"
                    class="continue-editing secondary mr-2"
                >
                    Turpināt
                </b-button>
                <b-button @click="closeAllModals()" class="stop-editing">
                    Pārtraukt rediģēšanu
                </b-button>
            </b-row>
        </b-modal>
    </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import audioRecorder from "../audoRecorder.js";

export default {
    name: "createNewRegionalWord",

    props: {
        id: Number,
    },
    data: () => {
        return {
            newRegionalWordForm: {
                name: "",
                description: "",
                administrative_territories_id: "",
                example: "",
                notes: "",
                user_id: "",
            },
            audio_file: "",
            formErrors: {},
            showConfirmationModal: false,
            showCreateRegionalWordForm: true,

            audioElement: {
                paused: false,
            },
            audioRecording: false,
            audioRecordStartTime: null,
            showRecordButton: true,
            showStopButton: false,
            elapsedTime: "",
            elapsedTimeTimer: null,
            maximumRecordingTimeInMinutes: 1,
            audio_blob: null,
            audio_file_removed: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "auth/user",
            administrativeTerritoriesList:
                "administrativeTerritories/administrativeTerritoriesList",
        }),
    },
    methods: {
        ...mapActions({
            saveNewRegionalWord: "regionalWords/saveNewRegionalWord",
            getRegionalWord: "regionalWords/getRegionalWord",
            saveRegionalWordChanges: "regionalWords/saveRegionalWordChanges",
            getAdministrativeTerritories:
                "administrativeTerritories/getAdministrativeTerritories",
            updateData: "regionalWords/updateData",
        }),
        closeModal(data) {
            this.$emit("closeCreateRegionalWordModal", data);
        },
        confirmAction(bvModalEvent) {
            bvModalEvent.preventDefault();

            if (
                this.newRegionalWordForm.name ||
                this.newRegionalWordForm.description ||
                this.newRegionalWordForm.administrative_territories_id ||
                this.newRegionalWordForm.example ||
                this.newRegionalWordForm.notes
            ) {
                this.showConfirmationModal = true;
            } else {
                this.closeModal();
            }
        },
        saveRegionalWord() {
            if (this.id) {
                this.updateRegionalWord();
            } else {
                this.createRegionalWord();
            }
        },
        redoRecording() {
            this.audio_file = null;
            this.audio_blob = null;
        },
        async createRegionalWord() {
            this.formErrors = {};
            this.newRegionalWordForm.user_id = this.user.id;

            let formData = new FormData();
            for (var key in this.newRegionalWordForm) {
                formData.append(key, this.newRegionalWordForm[key]);
            }
            if (this.audio_file) {
                formData.append("file", this.audio_file);
            }

            this.saveNewRegionalWord(formData)
                .then((response) => {
                    // console.log("createRegionalWord => saved", response);
                    this.updateData();
                    this.closeModal({
                        showMessage: true,
                        title: "Darbības apstiprinājums",
                        body: "Apvidvārds saglabāts!",
                        variant: "success",
                    });
                })
                .catch((error) => {
                    const errorsData = error.response;
                    if (errorsData && errorsData.data.errors) {
                        const errorKeys = Object.keys(errorsData.data.errors);
                        let errorMessages = {};
                        errorKeys.forEach((key) => {
                            errorMessages[key] = errorsData.data.errors[key][0];
                        });
                        this.formErrors = errorMessages;
                    }
                    this.$bvToast.toast(
                        "Apvidvārda pievienošana neizdevās! Pārbaudiet ievadītos datus!",
                        {
                            title: "Darbības atcelta",
                            variant: "danger",
                        }
                    );
                });
        },
        async fetchRegionalWord() {
            await this.getRegionalWord(this.id).then((response) => {
                const {
                    name,
                    description,
                    administrative_territories_id,
                    example,
                    notes,
                    user_id,
                } = response.data;
                this.newRegionalWordForm = {
                    name,
                    description,
                    administrative_territories_id,
                    example,
                    notes,
                    user_id,
                };
                // console.log(response);
                if (
                    response.data.audio_records &&
                    response.data.audio_records.length
                ) {
                    const audioRecord = response.data.audio_records[0];
                    this.audio_file = `/storage/records/${audioRecord.hashed_dir}/${audioRecord.hashed_name}.${audioRecord.extension}`;
                    this.audio_file_removed = false;
                    this.audio_blob = `/storage/records/${audioRecord.hashed_dir}/${audioRecord.hashed_name}.${audioRecord.extension}`;
                }
            });
        },
        async updateRegionalWord() {
            this.formErrors = {};
            this.newRegionalWordForm.id = this.id;

            let formData = new FormData();
            for (var key in this.newRegionalWordForm) {
                formData.append(key, this.newRegionalWordForm[key]);
            }
            if (this.audio_file) {
                // console.log("this.audio_file", this.audio_file);
                formData.append("file", this.audio_file);
            }
            if (this.audio_file_removed) {
                formData.append("audio_file_removed", this.audio_file_removed);
            }

            this.saveRegionalWordChanges(formData)
                .then((response) => {
                    // console.log("updateRegionalWord => updated", response);
                    if (this.$route.name === "regionalWordView") {
                        this.$eventBus.$emit("reloadRegionalWordView");
                    } else {
                        this.updateData();
                    }
                    this.closeModal({
                        showMessage: true,
                        title: "Darbības apstiprinājums",
                        body: "Apvidvārda izmaiņas saglabātas!",
                        variant: "success",
                    });
                })
                .catch((error) => {
                    const errorsData = error.response;
                    if (errorsData && errorsData.data.errors) {
                        const errorKeys = Object.keys(errorsData.data.errors);
                        let errorMessages = {};
                        errorKeys.forEach((key) => {
                            errorMessages[key] = errorsData.data.errors[key][0];
                        });
                        this.formErrors = errorMessages;
                    }
                    this.$bvToast.toast(
                        "Apvidvārda izmaiņas nav saglabātas! Pārbaudiet ievadītos datus!",
                        {
                            title: "Darbības atcelta",
                            variant: "danger",
                        }
                    );
                });
        },
        closeAllModals() {
            this.showConfirmationWindow = false;
            this.closeModal();
        },
        computeElapsedTime(startTime) {
            //record end time
            let endTime = new Date();

            //time difference in ms
            let timeDiff = endTime - startTime;

            //convert time difference from ms to seconds
            timeDiff = timeDiff / 1000;

            //extract integer seconds that dont form a minute using %
            let seconds = Math.floor(timeDiff % 60); //ignoring uncomplete seconds (floor)

            //pad seconds with a zero if neccessary
            seconds = seconds < 10 ? "0" + seconds : seconds;

            //convert time difference from seconds to minutes using %
            timeDiff = Math.floor(timeDiff / 60);

            //extract integer minutes that don't form an hour using %
            let minutes = timeDiff % 60; //no need to floor possible incomplete minutes, becase they've been handled as seconds
            minutes = minutes < 10 ? "0" + minutes : minutes;

            //convert time difference from minutes to hours
            timeDiff = Math.floor(timeDiff / 60);

            //extract integer hours that don't form a day using %
            let hours = timeDiff % 24; //no need to floor possible incomplete hours, becase they've been handled as seconds

            //convert time difference from hours to days
            timeDiff = Math.floor(timeDiff / 24);

            // the rest of timeDiff is number of days
            let days = timeDiff; //add days to hours

            let totalHours = hours + days * 24;
            totalHours = totalHours < 10 ? "0" + totalHours : totalHours;

            if (totalHours === "00") {
                return minutes + ":" + seconds;
            } else {
                return totalHours + ":" + minutes + ":" + seconds;
            }
        },
        elapsedTimeReachedMaximumNumberOfHours(elapsedTime) {
            //Split the elapsed time by the symbo :
            let elapsedTimeSplitted = elapsedTime.split(":");

            //Turn the maximum recording time in hours to a string and pad it with zero if less than 10
            let maximumRecordingTimeInMinutesAsString =
                this.maximumRecordingTimeInMinutes < 10
                    ? "0" + this.maximumRecordingTimeInMinutes
                    : this.maximumRecordingTimeInMinutes.toString();

            //if it the elapsed time reach hours and also reach the maximum recording time in hours return true
            // console.log("elapsedTimeSplitted[0]", elapsedTimeSplitted[0]);

            // console.log("elapsedTimeSplitted", elapsedTimeSplitted);
            if (
                elapsedTimeSplitted.length === 2 &&
                elapsedTimeSplitted[0] === "01"
            )
                return true;
            //otherwise, return false
            else return false;
        },
        displayElapsedTimeDuringAudioRecording(elapsedTime) {
            //1. display the passed elapsed time as the elapsed time in the elapsedTime HTML element
            this.elapsedTime = elapsedTime;

            //2. Stop the recording when the max number of hours is reached
            if (this.elapsedTimeReachedMaximumNumberOfHours(elapsedTime)) {
                this.stopAudioRecording();
            }
        },

        handleElapsedRecordingTime() {
            //display inital time when recording begins
            this.displayElapsedTimeDuringAudioRecording("00:00");

            //create an interval that compute & displays elapsed time, as well as, animate red dot - every second
            this.elapsedTimeTimer = setInterval(() => {
                //compute the elapsed time every second
                let elapsedTime = this.computeElapsedTime(
                    this.audioRecordStartTime
                ); //pass the actual record start time
                //display the elapsed time
                this.displayElapsedTimeDuringAudioRecording(elapsedTime);
            }, 1000); //every second
        },
        handleDisplayingRecordingControlButtons() {
            this.showRecordButton = false;
            this.showStopButton = true;

            this.handleElapsedRecordingTime();
        },
        displayBrowserNotSupportedOverlay() {
            // console.log("TODO SHOW CANT RECORD MESSAGE");
        },
        recordAudio() {
            this.audioRecording = true;
            console.log("Recording Audio...");

            //If a previous audio recording is playing, pause it
            let recorderAudioIsPlaying = !this.audioElement.paused; // the paused property tells whether the media element is paused or not
            // console.log("paused?", !recorderAudioIsPlaying);
            if (recorderAudioIsPlaying) {
                // audioElement.pause();
                //also hide the audio playing indicator displayed on the screen
                // hideTextIndicatorOfAudioPlaying();
            }

            //start recording using the audio recording API
            audioRecorder
                .start()
                .then(() => {
                    //on success

                    //store the recording start time to display the elapsed time according to it
                    this.audioRecordStartTime = new Date();

                    //display control buttons to offer the functionality of stop and cancel
                    this.handleDisplayingRecordingControlButtons();
                })
                .catch((error) => {
                    //on error
                    //No Browser Support Error
                    if (
                        error.message.includes(
                            "mediaDevices API or getUserMedia method is not supported in this browser."
                        )
                    ) {
                        console.log(
                            "To record audio, use browsers like Chrome and Firefox."
                        );
                        this.displayBrowserNotSupportedOverlay();
                    }

                    //Error handling structure
                    switch (error.name) {
                        case "AbortError": //error from navigator.mediaDevices.getUserMedia
                            console.log("An AbortError has occured.");
                            break;
                        case "NotAllowedError": //error from navigator.mediaDevices.getUserMedia
                            console.log(
                                "A NotAllowedError has occured. User might have denied permission."
                            );
                            break;
                        case "NotFoundError": //error from navigator.mediaDevices.getUserMedia
                            console.log("A NotFoundError has occured.");
                            break;
                        case "NotReadableError": //error from navigator.mediaDevices.getUserMedia
                            console.log("A NotReadableError has occured.");
                            break;
                        case "SecurityError": //error from navigator.mediaDevices.getUserMedia or from the MediaRecorder.start
                            console.log("A SecurityError has occured.");
                            break;
                        case "TypeError": //error from navigator.mediaDevices.getUserMedia
                            console.log("A TypeError has occured.");
                            break;
                        case "InvalidStateError": //error from the MediaRecorder.start
                            console.log("An InvalidStateError has occured.");
                            break;
                        case "UnknownError": //error from the MediaRecorder.start
                            console.log("An UnknownError has occured.");
                            break;
                        default:
                            console.log(
                                "An error occured with the error name " +
                                    error.name
                            );
                    }
                });
        },
        handleHidingRecordingControlButtons() {
            this.showRecordButton = true;
            this.showStopButton = false;

            clearInterval(this.elapsedTimeTimer);
        },
        stopAudioRecording() {
            console.log("Stopping Audio Recording...");

            //stop the recording using the audio recording API
            audioRecorder
                .stop()
                .then((audioAsblob) => {
                    this.audioRecording = false;
                    //Play recorder audio
                    // playAudio(audioAsblob);
                    this.audio_file = audioAsblob;
                    // console.log(audioAsblob);
                    // console.log(window.URL.createObjectURL(audioAsblob));
                    // this.convertToBase64Url(audioAsblob);

                    // this.audio_file = e.target.result;
                    this.audio_blob = window.URL.createObjectURL(audioAsblob);

                    //hide recording control button & return record icon
                    this.handleHidingRecordingControlButtons();
                })
                .catch((error) => {
                    //Error handling structure
                    switch (error.name) {
                        case "InvalidStateError": //error from the MediaRecorder.stop
                            console.log("An InvalidStateError has occured.");
                            break;
                        default:
                            console.log(
                                "An error occured with the error name " +
                                    error.name
                            );
                    }
                });
        },
        convertToBase64Url(recorderAudioAsBlob) {
            let reader = new FileReader();

            //once content has been read
            reader.onload = (e) => {
                //store the base64 URL that represents the URL of the recording audio
                this.audio_file = e.target.result;
                // console.log("e target result", e.target.result);
            };

            //read content and convert it to a URL (base64)
            reader.readAsDataURL(recorderAudioAsBlob);
        },
        cancelAudioRecording() {
            console.log("Canceling audio...");

            //cancel the recording using the audio recording API
            // audioRecorder.cancel();
            this.audioRecording = false;
            //hide recording control button & return record icon
            this.handleHidingRecordingControlButtons();
            this.audio_blob = null;
            this.audio_file = null;
            this.audio_file_removed = true;
        },

        playAudio(recorderAudioAsBlob) {
            //read content of files (Blobs) asynchronously
            let reader = new FileReader();

            //once content has been read
            reader.onload = (e) => {
                //store the base64 URL that represents the URL of the recording audio
                let base64URL = e.target.result;

                //If this is the first audio playing, create a source element
                //as pre populating the HTML with a source of empty src causes error
                // if (!audioElementSource)
                //if its not defined create it (happens first time only)
                // createSourceForAudioElement();

                //set the audio element's source using the base64 URL
                audioElementSource.src = base64URL;

                //set the type of the audio element based on the recorded audio's Blob type
                let BlobType = recorderAudioAsBlob.type.includes(";")
                    ? recorderAudioAsBlob.type.substr(
                          0,
                          recorderAudioAsBlob.type.indexOf(";")
                      )
                    : recorderAudioAsBlob.type;
                audioElementSource.type = BlobType;

                //call the load method as it is used to update the audio element after changing the source or other settings
                audioElement.load();

                //play the audio after successfully setting new src and type that corresponds to the recorded audio
                console.log("Playing audio...");
                audioElement.play();

                //Display text indicator of having the audio play in the background
                displayTextIndicatorOfAudioPlaying();
            };

            //read content and convert it to a URL (base64)
            reader.readAsDataURL(recorderAudioAsBlob);
        },
    },
    mounted() {
        this.getAdministrativeTerritories();

        if (this.id) {
            this.fetchRegionalWord();
        }
    },
};
</script>

<style lang="scss">
@import "~@/_variables.scss";

#regional-word-create {
    z-index: 999999;
}

.example {
    width: 100%;
}

.notes {
    width: 100%;
}

.name {
    width: 100%;
}

.description {
    width: 100%;
}

.location {
    width: 100%;
}

.close-icon {
    color: $grey-text;
    cursor: pointer;
    width: 20px;
    height: 20px;
}

.location-row {
    border-top: 1px solid $grey-text;
    border-bottom: 1px solid $grey-text;
}

.create-regional-word-button {
    background-image: linear-gradient($gradient-yellow, $gradient-red);
    font-weight: 700;
}

.actions {
    justify-content: flex-end;
}

.stop-editing {
    background-image: linear-gradient($gradient-yellow, $gradient-red);
    font-weight: 700;
}

.vue-audio-recorder {
    background-color: $black !important;
    width: 40px !important;
    height: 40px !important;
}

.vue-audio-recorder.active {
    background-color: #ef5350 !important;
}

// .audio-file {
//     display: flex;
//     align-items: center;
//     span {
//         font-size: 26px;
//     }
//     audio {
//         height: 40px;
//     }
// }

.redo-audio {
    width: 40px;
    height: 40px;
    color: grey;
    cursor: pointer;

    &:hover {
        color: $black;
    }
}

.info-tooltip-icon {
    position: absolute;
    top: 10px;
    right: 6px;
}

.input-row {
    position: relative;
}

.info-tooltip-icon-textarea {
    position: absolute;
    right: 20px;
}

.location-row {
    position: relative;
    .info-tooltip-icon {
        position: absolute;
        top: 35px;
        right: 0px;
    }
}

.instructions {
    justify-content: flex-end;
}
.link-to-instructions {
    color: $grey-text;

    &:hover {
        color: $black;
    }
}

@media (max-width: $xs-media) {
    .create-regional-word-button {
        width: 100%;
        .audio-file audio {
            width: inherit;
        }
    }
}

.icon-divider {
    font-size: 26px;
}
.record-icon {
    width: 32px;
    height: 32px;
    cursor: pointer;
}

.stop-icon {
    width: 32px;
    height: 32px;
    cursor: pointer;
}

.cancel-recording {
    width: 32px;
    height: 32px;
    cursor: pointer;
}

.elapsed-time {
    font-size: 26px;
}

.audio-file {
    display: flex;
    align-items: center;
    span {
        font-size: 26px;
    }
    audio {
        height: 40px;
    }
}

.audio-recorder-wrapper label {
    color: $grey-text;
}
</style>
